((Drupal, drupalSettings) => {
  const counterRunning = {}; // Are the counters running yet
  const counterTotal = {}; // Keep a running total for the counters

  /**
   * Returns all internal counter elements from the page.
   * @return {NodeListOf<Element>}
   */
  const getCounterElements = () =>
    document.querySelectorAll(".webform_external_counter");

  /**
   * Smoothly increments the displayed total towards the target value.
   * @param {Object} counter
   * @param {number} current
   * @param {number} total
   */
  const incrementTotal = (counter, current, total) => {
    if (current < total - 0.5) {
      const newValue = current + (total - current) / 10;
      const delay = Math.max(50, 200 / (total - newValue));

      document.querySelectorAll(`.${counter.id}`).forEach((el) => {
        el.innerHTML = Math.round(newValue)
          .toLocaleString()
          .replace(/\..*/, "");
      });

      setTimeout(() => incrementTotal(counter, newValue, total), delay);
    } else {
      counterRunning[counter.id] = false;
    }
  };

  /**
   * Fetches data from the internal API.
   * @param {Object} counter
   * @param {boolean} [update=true]
   */
  const fetchFromUrl = async (counter, update = true) => {
    try {
      const response = await fetch(counter.webformUrl);
      const data = await response.json();
      const total = data.result[0].q;

      if (update) {
        incrementTotal(counter, counterTotal[counter.id] ?? 0, total);
      }

      counterTotal[counter.id] = total;
    } catch (err) {
      console.error(
        `[webform_external_counter] Failed to fetch ${counter.webformUrl}:`,
        err
      );
    }
  };

  /**
   * Uses IntersectionObserver to trigger the counter animation when
   * the element scrolls into view, or starts immediately if already visible.
   * @param {Object} counter
   */
  const countOrWaitForScroll = (counter) => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // setInterval(() => fetchFromUrl(counter), 10000);
            incrementTotal(counter, 0, counterTotal[counter.id] ?? 0);
            obs.disconnect();
          }
        });
      },
      { threshold: 1.0 }
    ); // fully visible

    observer.observe(counter.element);
  };

  /**
   * Initialises all counters found on the page.
   */
  const init = (context) => {
    // const elements = getCounterElements();

    const counterMap = {};

    const tracks = once(
      "wwf_track_total",
      ".webform_external_counter",
      context
    );

    tracks.forEach((el) => {
      const classes = el.className.split(" ");
      const id = classes[1];

      // Only keep the first occurrence of each counter id.
      if (counterMap[id]) return;

      counterMap[id] = {
        id,
        element: el,
        classes,
        intervalTimer: el.dataset.intervalTimer,
        webformUrl: el.dataset.webformUrl,
        startAtTotal: Number(el.dataset.startAtTotal) || 0,
        total: 0,
      };
    });

    const counters = Object.values(counterMap);

    counters.reduce(
      (chain, counter) =>
        chain
          .then(() => fetchFromUrl(counter, false))
          .then(() => {
            // Start the display 50 below the real total so the animation has room to run.
            counter.total = (counterTotal[counter.id] ?? 0) - 50;
            counterTotal[counter.id] = counter.total;
            counterRunning[counter.id] = false;
            countOrWaitForScroll(counter);
          }),
      Promise.resolve()
    );
    // .then(() =>
    //   counters.reduce(
    //     (chain, counter) =>
    //       chain.then(() => {
    //         if (counter.total > counter.startAtTotal) {
    //           return fetchFromUrl(counter).then(() =>
    //             countOrWaitForScroll(counter)
    //           );
    //         }
    //       }),
    //     Promise.resolve()
    //   )
    // );
  };

  Drupal.behaviors.webform_external_counter = {
    attach(context) {
      init(context);
    },
  };
})(Drupal, drupalSettings);
